module.exports = __webpack_public_path__ + "prod/1.42.2/img/logo_wall.63365446.png";